import { types as CareTypes } from 'store/Care'
import { types as PolicyTypes } from 'store/Policy'
import { isStaleResponse } from 'store/Care/utils/isStaleResponse'
import { parseDetailWithPolicy } from './utils/parseDetailWithPolicy'

export const types = {
  CLEAR_CARE_UI_STATE: 'CLEAR_CARE_UI_STATE',
}

/**
 * Used to clear the state when the detail page unmounts. Without this, some
 * pricing information and flags will unintentionally persist.
 */
export const clearCareUIState = () => ({
  type: types.CLEAR_CARE_UI_STATE,
})

export const initialState = {
  careCovered: false,
  isCoverAtCostNotEB: false,
  shouldCost: 0,
  benefitAmount: 0,
  benefitAmountOrCovered: '',
  costListType: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    // We definitely need this for normal single detail pages, but we also
    // need this for the _main_ cost of an episode of care. Each item for
    // that episode will also have to have its costs calculated and that's
    // not really done here. Just know that there are 2 places the price
    // needs to be calculated for an episode.
    case CareTypes.FETCH_CARE_DETAIL_SUCCESS:
    case CareTypes.FETCH_CARE_EPISODE_SUCCESS: {
      // Prices derived from a superseded detail response would contradict the
      // care item actually on screen, so discard it here too (BASH-219).
      // `action.state` is the store as of dispatch, added by `addStateToAction`,
      // so `detail.requestId` is still the request the page is waiting for.
      const awaitedRequestId = action.state?.Care?.detail?.requestId
      if (isStaleResponse(action.meta?.requestId, awaitedRequestId)) {
        return state
      }

      // Get care detail from payload and policy from state.
      // There is middleware (`preParseCareDetail`) that parses out the payload
      // once for all the reducers. That's what this `payload` is.
      const careDetail = action.payload
      const policy = action.state.Policy?.policy?.entity

      return {
        ...state,
        ...parseDetailWithPolicy(state, careDetail, policy),
      }
    }

    // When policy is fetched successfully
    case PolicyTypes.FETCH_POLICY_SUCCESS: {
      // Get policy from payload and care detail from state. Theoretically,
      // this careDetail should've already been parsed properly when it saved.
      const policy = action.payload
      const careDetail = action.state.Care?.detail?.entity

      return {
        ...state,
        ...parseDetailWithPolicy(state, careDetail, policy),
      }
    }

    // Reset state to initial values
    case types.CLEAR_CARE_UI_STATE:
      return initialState

    default:
      return state
  }
}
